import React from 'react'
import InputWithLabel from './../../../../commons/InputWithLabel'

class Loan extends React.Component {
  onChange = (params) => {
    this.props.onChange(params)
  }

  render() {
    const {
      monthlyRepayment,
      outstandingBalance,
      provider,
      owner,
      errors,
    } = this.props.commitment;

    return(
      <div className='card-body'>
        <InputWithLabel
          label="Outstanding balance"
          type='currency'
          defaultValue={ outstandingBalance }
          errorMessage={ errors['outstandingBalance'] }
          onChange={ (value) => { this.onChange({outstandingBalance: value}) } }
        />
        <InputWithLabel
          label="Monthly repayment"
          type='currency'
          defaultValue={ monthlyRepayment }
          errorMessage={ errors['monthlyRepayment'] }
          onChange={ (value) => { this.onChange({monthlyRepayment: value}) } }
        />
        <InputWithLabel
          label='Provider'
          type='select'
          borderStyle='responsive'
          defaultValue={ provider }
          errorMessage={ errors['provider'] }
          options={ this.props.availableProviders }
          onChange={ (value) => { this.onChange({provider: value}) } }
        />
      {this.props.ownerOptions.length > 0 &&
        <InputWithLabel
          label='Owner'
          type='select'
          borderStyle='responsive'
          defaultValue={ owner }
          errorMessage={ errors['owner'] }
          options={ this.props.ownerOptions }
          onChange={ (value) => { this.onChange({owner: value}) } }
        />
      }
      </div>
    )
  }
}

export default Loan;
